import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import HelpPage from "./pages/HelpPage";
import ParentMontessoriMenu from "./ParentMontessoriMenu";
import Index from "./pages/Index";
import Settings from "./pages/components/Settings";
import AdmissionProfile from "./pages/components/admission/AdmissionProfile";
import SwitchAdmission from "./pages/components/admission/SwitchAdmission";
import HomeWork from "../parent/pages/is-kool-jr/messages/HomeWorkBroadcast";
import ViewFeeDetails from "./pages/components/fee/ViewFeeDetails";
import InstructorConverstion from "./pages/is-kool-jr/messages/InstructorConverstion";
import MontessoriReportList from "./pages/is-kool-jr/montessori-progress-card/MontessoriReportList";
import MontessoriViewCard from "./pages/is-kool-jr/montessori-progress-card/MontessoriViewCard";
import ParentSwitchTransportation from "./pages/components/transportation/SwitchTransportation";
import ParentLiveTracking from "./pages/Live tracking";
import SwitchMontessoriAttendance from "./pages/is-kool-jr/attendance/SwitchMontessoriAttendance";
import SwitchDailyActivity from "./pages/is-kool-jr/daily-activity/SwitchDailyActivity";
import ParentCourseBoard from "./pages/is-kool-jr/course-board/ParentCourseBoard";
import SwitchParentForm from "./pages/components/manageform/SwitchParentForm";
import TripConsentList from "./pages/components/trip/TripConsentList";

const url = "/dashboard";

const ParentMontessoriRoutes = () => {
  return (
    <Routes>
      <Route path="parent/menu" element={<ParentMontessoriMenu />} />
      <Route path="parent/menu/admission" element={<SwitchAdmission />} />
      <Route path="parent/menu/admission/:id" element={<AdmissionProfile />} />
      <Route path="parent/menu/homework" element={<HomeWork />} />
      <Route path="parent/menu/course-board" element={<ParentCourseBoard />} />
      <Route path="parent/menu/fee" element={<ViewFeeDetails />} />
      <Route path="parent/menu/attendance" element={<SwitchMontessoriAttendance />} />
      <Route path="parent/menu/daily-activity" element={<SwitchDailyActivity />} />
      <Route path="parent/help" element={<HelpPage />} />
      <Route path="parent/menu/setting/" element={<Settings />} />
      <Route path="parent/menu/message/" element={<InstructorConverstion />} />
      <Route path="parent/menu/transportation/" element={<ParentSwitchTransportation />} />
      <Route path="parent/menu/live-tracking/" element={<ParentLiveTracking />} />
      <Route path="parent/home" element={<Index />} />
      <Route path="parent/menu/montessori-report-card/" element={<MontessoriReportList />} />
      <Route path="parent/menu/montessori-report-card/:id" element={<MontessoriViewCard />} />
      <Route path="parent/menu/manage-form/" element={<SwitchParentForm />} />
      <Route path="parent/menu/consent-form" element={<TripConsentList />} />
      <Route index element={<Navigate to={`${url}/parent/home`} replace />} />
    </Routes>
  );
};

export default ParentMontessoriRoutes;
